import React from 'react'

//page hooks
import UseWorkspaceUserGroupsScreen from './WorkspaceUserGroupsScreen.hooks';

//components
import BasicButton from  '@/components/elements/global/buttons/BasicButton/BasicButton';
import SimplePageSelector from  '@/components/elements/global/PageSelectors/SimplePageSelector';
import SimpleTable from  '@/components/elements/global/tables/SimpleTable/SimpleTable';
import LinkStyleButton from  '@/components/elements/global/buttons/LinkStyleButton';
import CheckboxPanel from  '@/components/elements/global/dropdown/CheckboxPanel';
import SimpleSearchInput from  '@/components/elements/search/simpleSearchInput';
import AddNewUserGroupModal from  '@/components/modals/orgSettings/workspaces/AddNewUserGroupModal';
import NotificationBar from  '@/components/elements/languages/NotificationBar';
import NoUserGroupsPanel from  '@/components/elements/orgSettings/workspaceUserGroups/NoUserGroupsPanel';
import LoadingSpinner from  '@/components/elements/search/LoadingSpinner/LoadingSpinner';

//styling
import "../../../../../css/orgSettings/userGroups/usersGroups.scss"



const WorkspaceUserGroupsScreen = () => {  
    const {filterButtonText, filterButtonLabel, searchInputLabel, panelTitle, archivedGroupLabel, noDataMessage, addNewGroupButtonText, addNewGroupButtonLabel, setSearchString, searchString, paginationSettings, tableContent, showSimpleTable, onAddNewUserGroupClick, setIncludeArchivedUserGroups, onHideModalClick, includeArchivedUserGroups, showFilterPanel, setShowFilterPanel, showAddNewGroupModal, isLoading, notificationDetails, getNewPage, showNoUserGroupsPanel, onAddAllUsersClick} = UseWorkspaceUserGroupsScreen();
    
    return( 
        <>
        <div className="user-groups-tab-container" data-testid="workspace-user-groups">
            {showSimpleTable 
                ?   <>
                    <div className='user-groups-top-button-panel'> 
                        <LinkStyleButton content={filterButtonText} ariaLabel={filterButtonLabel} onButtonClick={() => setShowFilterPanel(!showFilterPanel)}  />
                        <SimpleSearchInput ariaLabel={searchInputLabel} setSearchString={setSearchString} searchString={searchString} />
                    </div>

                    {showFilterPanel && <CheckboxPanel panelTitle={panelTitle} items={[{id: 1, content:archivedGroupLabel, isSelected: includeArchivedUserGroups, onCheck: ()=> setIncludeArchivedUserGroups(!includeArchivedUserGroups)}]} /> }
                    
                    <SimpleTable isPaginated paginationInformation={paginationSettings} isLoading={isLoading} simpleTableContent={tableContent} noDataMessage={noDataMessage} maxContentLength={20} isInfiniteScroll={false} />

                    {paginationSettings?.hasPagination &&  <SimplePageSelector currentPage={paginationSettings.currentPage} totalPages={paginationSettings.totalPages} setPage={getNewPage} />}

                    <div className='user-groups-button-panel'>
                        <BasicButton content={addNewGroupButtonText} ariaLabel={addNewGroupButtonLabel} onButtonClick={onAddNewUserGroupClick}/>
                    </div>
                    </>

                :   showNoUserGroupsPanel && <NoUserGroupsPanel onAddAllUserGroupsClick={onAddAllUsersClick} onSelectGroupsClick={onAddNewUserGroupClick}/>
            }

            {!showSimpleTable && !showNoUserGroupsPanel && <LoadingSpinner size={30} />}

            <AddNewUserGroupModal showModal={showAddNewGroupModal} hideModal={onHideModalClick}/>
        </div>

        <NotificationBar show={notificationDetails.show} notificationStatus={notificationDetails.status} msg={notificationDetails.message} />
        </>
    )
}

export default WorkspaceUserGroupsScreen